import axios from "axios";

import { notify } from "@/utils";
import { logError } from "@/utils/logger";

export const baseApiUrl = getApiUrl();

export const apiUrl = getApiUrl("/" + import.meta.env.VITE_API_VERSION);

export const adminApiUrl = getApiUrl(
  "/admin/" + import.meta.env.VITE_API_VERSION,
);

export const api = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
});

export const adminApi = axios.create({
  baseURL: adminApiUrl,
  withCredentials: true,
});

api.defaults.withXSRFToken = true;
adminApi.defaults.withXSRFToken = true;

export function shouldRetryOnError(failureCount: number, error: any) {
  if (failureCount >= 2) {
    return false;
  }

  if (axios.isAxiosError(error)) {
    const status = error.response?.status || 0;
    return status < 400 || status >= 500;
  }

  return true;
}

export function getApiError(payload: any): string | undefined {
  if (!axios.isAxiosError(payload) || !payload.response?.data) return;

  const data = payload.response.data;

  if (typeof data.message === "string") {
    return data.message;
  }

  return;
}

export function handleApiError(error: any, hideError: boolean) {
  const isValidationError =
    axios.isAxiosError(error) &&
    error.response?.status === 422 &&
    error.response?.data &&
    "errors" in error.response.data;

  const message = getApiError(error);

  if (!isValidationError && !hideError && message) {
    notify.error(message);
  }

  logError("Error message: " + message);
}

export function getApiUrl(url?: string) {
  const template = import.meta.env.VITE_API_URL;
  const domainReplacement = /\{domain\}:/.test(template)
    ? window.location.hostname
    : window.location.host;
  const baseUrl = template.replace(/\{domain\}/g, domainReplacement);

  if (!url) return baseUrl;

  const cleanBase = baseUrl.replace(/\/$/, "");
  const cleanUrl = url.replace(/^\//, "");

  return `${cleanBase}/${cleanUrl}`;
}

export function getCurrentVersionApiUrl(url?: string) {
  const cleanUrl = url?.replace(/^\//, "");

  return getApiUrl(
    import.meta.env.VITE_API_VERSION + (cleanUrl ? "/" + cleanUrl : ""),
  );
}
